import { getRoutes } from "../api/userApi";

export const onLandFetchData = async (refresh) => {
    await routesFetcher(refresh);
}

export const routesFetcher = async (refresh) => {
    const routes = JSON.parse(localStorage.getItem("routes") || "[]");
    if (!routes?.length || refresh) {
        const res = await getRoutes();
        localStorage.setItem("routes", JSON.stringify(res.routes) || [])
        return true;
    } else {
        return routes;
    }
}